// extracted by mini-css-extract-plugin
module.exports = {"Main_Container":"Bar_Main_Container__3z1Bn","Navbar":"Bar_Navbar__Q6pAK","Body":"Bar_Body__3xE7m"};